export const DEC_INC_VALIDATIONS = [
    {
        name: "amount",
        validations: ['required']
    },
   
]
